import { observer } from "mobx-react";
import { SendWireBaseStore } from "../stores";
import { Grid, Typography } from "@material-ui/core";
import { DrawDQDataGrid } from "./drawDQDataGrid";
import DrawsToConsolidateGrid from "./drawsToConsolidateGrid";
import { WireDetails } from "./wireDetails";


export interface SendWireProps {
  store: SendWireBaseStore;
}

export const SendWireFirstStep = observer((props: SendWireProps) => {
  const { store } = props;
  return (
    <Grid container spacing={2} xs={12} justifyContent="flex-end">
      <Grid item xs={12}>
        <Typography>Please select draws to consolidate</Typography>
      </Grid>
      <Grid item xs={12}>
        <DrawsToConsolidateGrid/>
      </Grid>
      <Grid item xs={12}>
        <Typography>Please select loans to apply delinquencies</Typography>
      </Grid>
      <Grid item xs={12} style={{paddingBottom: '25px'}}>
        <DrawDQDataGrid/>
      </Grid>
      <Grid item md={6} xs={12}>
        <WireDetails/>
      </Grid>
    </Grid>
  )
});